enum ExportType {
  PDF = 0, // eslint-disable-line no-unused-vars
  Excel = 1, // eslint-disable-line no-unused-vars
}

export default ExportType;
